module.exports = __webpack_public_path__ + "static/media/TT11 ELETROSTÁTICO.d4afaa93.png";